import "./EdecidePanel.scss";

import { InlineSpinner } from "components/InlineSpinner";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useEdecidePanel, useTranslations } from "providers";
import React from "react";

import { EdecidePanelFooter } from "./EdecidePanelFooter";
import { EdecidePanelPreview } from "./EdecidePanelPreview";
import { EdecideRunResult } from "./EdecideRunResult";

export const EdecidePanel: React.FC = () => {
  const i18n = useTranslations();

  const { isOpen, isLoading, isSubmitting, isPreview, isResult, error, closeEdecidePanel } = useEdecidePanel();

  // Return null if panel is closed
  if (!isOpen) {
    return null;
  }

  return (
    <SlidingPanel
      isOpen={true}
      size={30}
      onClose={closeEdecidePanel}
      panelContainerClassName="edecide-panel"
      header={<h1>{i18n.EdecidePanel_Header}</h1>}
      footer={<EdecidePanelFooter />}
    >
      <>
        {isLoading && <InlineSpinner text={i18n.EdecidePanel_Loading} />}
        {isPreview && <EdecidePanelPreview />}
        {isSubmitting && <InlineSpinner text={i18n.EdecidePanel_Submitting} />}
        {isResult && <EdecideRunResult />}
        {error && <div className="alert alert-danger">{error.message}</div>}
      </>
    </SlidingPanel>
  );
};
